import React, { useEffect, useState } from 'react';
import { Settings, Volume2, VolumeX, Music, Music2, Gamepad2 } from 'lucide-react';
import { gbAudioCfg, gbAudioSet, gbSfx } from './gbSfx';

const PADRAO = { muted: false, sfxOn: true, sfxVol: 1, musicOn: true, musicVol: 0.8 };

const Barra = ({ valor, desligado, testid, onChange }) => (
  <input type="range" min="0" max="100" step="5" disabled={desligado} data-testid={testid}
    value={Math.round(valor * 100)}
    onChange={(e) => onChange(Number(e.target.value) / 100)}
    className={`mt-2 h-1.5 w-full cursor-pointer appearance-none rounded-full bg-purple-950 ${desligado ? 'opacity-30' : ''}`}
    style={{ accentColor: '#fb923c' }} />
);

// controle de áudio da arena (mesmo ajuste que vale dentro das partidas)
export const GbAudioMenu = () => {
  const [aberto, setAberto] = useState(false);
  const [cfg, setCfg] = useState(PADRAO);

  useEffect(() => { gbAudioCfg().then((c) => { if (c) setCfg(c); }); }, []);

  const aplicar = (patch, bip = true) => {
    gbAudioSet(patch).then((c) => { if (c) setCfg(c); });
    if (bip) gbSfx('click');
  };

  return (
    <div className="relative flex-none">
      <button onClick={() => { setAberto((v) => !v); gbSfx('click'); }}
        data-testid="gb-audio-gear" title="Som do jogo"
        className={`flex h-9 w-9 items-center justify-center rounded-full border transition-colors ${
          cfg.muted
            ? 'border-rose-700/70 bg-rose-950/40 text-rose-300'
            : 'border-purple-800/60 text-purple-300 hover:border-orange-500/70 hover:text-orange-300'}`}>
        {cfg.muted ? <VolumeX className="h-4 w-4" /> : <Settings className="h-4 w-4" />}
      </button>

      {aberto && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setAberto(false)} />
          <div className="absolute left-0 top-11 z-50 w-56 space-y-2 rounded-2xl border border-purple-700/60 bg-[#140b22] p-2.5 shadow-[0_18px_40px_rgba(0,0,0,.7)]"
            data-testid="gb-audio-panel">
            <p className="text-[9px] font-black uppercase tracking-[0.22em] text-purple-300/70">som do jogo</p>

            <button onClick={() => aplicar({ muted: !cfg.muted })} data-testid="gb-audio-mute"
              className={`flex w-full items-center justify-between rounded-xl border px-2.5 py-2 ${
                cfg.muted ? 'border-rose-700/70 bg-rose-950/50' : 'border-purple-800/60 bg-black/40'}`}>
              <span className="flex items-center gap-1.5 text-xs font-bold text-purple-100">
                {cfg.muted ? <VolumeX className="h-3.5 w-3.5 text-rose-400" /> : <Volume2 className="h-3.5 w-3.5 text-emerald-400" />}
                Mudo
              </span>
              <span className={`text-[10px] font-black ${cfg.muted ? 'text-rose-300' : 'text-purple-400/70'}`}>
                {cfg.muted ? 'TUDO MUDO' : 'OFF'}
              </span>
            </button>

            <div className="rounded-xl border border-purple-800/60 bg-black/40 px-2.5 py-2">
              <button onClick={() => aplicar({ sfxOn: !cfg.sfxOn })} data-testid="gb-audio-sfx"
                className="flex w-full items-center justify-between">
                <span className="flex items-center gap-1.5 text-xs font-bold text-purple-100">
                  <Gamepad2 className="h-3.5 w-3.5 text-orange-400" />Sons do jogo
                </span>
                <span className={`text-[10px] font-black ${cfg.sfxOn && !cfg.muted ? 'text-emerald-300' : 'text-purple-400/70'}`}>
                  {cfg.sfxOn ? 'ON' : 'OFF'}
                </span>
              </button>
              <Barra valor={cfg.sfxVol} desligado={cfg.muted || !cfg.sfxOn} testid="gb-audio-sfx-vol"
                onChange={(v) => aplicar({ sfxVol: v }, false)} />
            </div>

            <div className="rounded-xl border border-purple-800/60 bg-black/40 px-2.5 py-2">
              <button onClick={() => aplicar({ musicOn: !cfg.musicOn })} data-testid="gb-audio-music"
                className="flex w-full items-center justify-between">
                <span className="flex items-center gap-1.5 text-xs font-bold text-purple-100">
                  {cfg.musicOn ? <Music className="h-3.5 w-3.5 text-orange-400" /> : <Music2 className="h-3.5 w-3.5 text-purple-500" />}
                  Música
                </span>
                <span className={`text-[10px] font-black ${cfg.musicOn && !cfg.muted ? 'text-emerald-300' : 'text-purple-400/70'}`}>
                  {cfg.musicOn ? 'ON' : 'OFF'}
                </span>
              </button>
              <Barra valor={cfg.musicVol} desligado={cfg.muted || !cfg.musicOn} testid="gb-audio-music-vol"
                onChange={(v) => aplicar({ musicVol: v }, false)} />
            </div>

            <p className="px-0.5 text-[10px] leading-snug text-purple-300/55">
              Vale também dentro das partidas — lá o controle fica na engrenagem.
            </p>
          </div>
        </>
      )}
    </div>
  );
};

export default GbAudioMenu;
